export const styles = {
  anchor: {
    cursor: 'pointer',
    textDecoration: 'none !important',
    '&:hover': {
      textDecoration: 'none !important',
    },
    '&:active': {
      textDecoration: 'none !important',
    },
  },
}
